/**
 * /dashboard/hiring/requisitions/new — Create a requisition (Phase H.8).
 *
 * POST /hiring/requisitions is HR-admin + CSRF + Audit server-side;
 * HrAdminGate hard-gates the form so a non-admin sees a clean "no
 * access" state.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/hiring/requisitions/new/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { HiringModuleShell } from "@/components/shared/hiring-module-shell";
import { HiringFeatureGate } from "@/components/hiring/hiring-feature-gate";
import { HrAdminGate } from "@/components/hiring/hr-admin-gate";
import { RequisitionForm } from "@/components/hiring/requisition-form";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/hiring/requisitions/new",
)({
  component: NewRequisitionRoute,
});

function NewRequisitionRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <HiringModuleShell
      title="New requisition"
      description="Open a new role. Make it open + public to list it on your careers page."
      actions={
        <Button asChild variant="outline" className="gap-1.5">
          <Link to="/app/$tenantSlug/hiring/requisitions" params={{ tenantSlug }}>
            <ArrowLeft className="h-4 w-4" />
            Back to Requisitions
          </Link>
        </Button>
      }
    >
      <HiringFeatureGate>
        <HrAdminGate
          title="New requisition"
          description="Open a new role to hire for."
        >
          <Card>
            <CardContent className="pt-6">
              <RequisitionForm />
            </CardContent>
          </Card>
        </HrAdminGate>
      </HiringFeatureGate>
    </HiringModuleShell>
  );
}
